import { EntityData } from "@/components/TriggerSetup/logic/types/entity-data.type";
import { baseCondition } from "@/components/TriggerSetup/logic/structures/base-condition.structure";
import { TriggerCondition } from "@/components/TriggerSetup/logic/types/types";
import { snakeCase } from "lodash";
import { getTagsByFieldKey } from '@/mixins/TariffsTagsHelper'
import i18n from '@/i18n/i18n'
import MessageMentionEntityRegexpTypeSetupView
  from '@/components/TriggerSetup/conditions/MessageMentionEntityRegexpType/MessageMentionEntityRegexpTypeSetupView.vue'

const condition: () => EntityData = () => {
  return {
    'setupView': MessageMentionEntityRegexpTypeSetupView,
    'structure': {
      'type': 'MessageMentionEntityRegexpType',
      ...baseCondition,
    } as TriggerCondition,
    'titleKey': `trigger_condition_${ snakeCase('MessageMentionEntityRegexpType') }`,
    'limited': getTagsByFieldKey('MessageMentionEntityRegexpTypeCondition'),
    'helpMessage': i18n.t('regexp_condition_help_message').toString()
  }
}

export default condition
